import React from 'react';
import { Button } from 'react-bootstrap';
import { WEB_PUSH_STATE } from '../../utils/webPushState';
import { needsIosHomeScreen, useWebPush } from '../../hooks/useWebPush';

/*
 * Web Push v0 — управление уведомлениями на текущем устройстве.
 *
 * Канал уведомлений живёт отдельным слоем и с UI правил не связан (ТЗ 12).
 * Prompt браузера вызывается только по нажатию кнопки ниже.
 */

const WebPushSection = () => {
  const { state, busy, error, enable, disable } = useWebPush();

  // Неавторизованному пользователю секция не нужна: 401 на public-key — это не
  // недоступность push.
  if (state === WEB_PUSH_STATE.UNAUTHORIZED) return null;

  const renderBody = () => {
    if (state === WEB_PUSH_STATE.UNSUPPORTED) {
      return <p className="pp-webpush-note">Этот браузер не поддерживает push-уведомления.</p>;
    }

    if (state === WEB_PUSH_STATE.BACKEND_UNAVAILABLE) {
      return <p className="pp-webpush-note">Сервис уведомлений временно недоступен.</p>;
    }

    if (state === WEB_PUSH_STATE.PERMISSION_DENIED) {
      return (
        <p className="pp-webpush-note">
          Уведомления заблокированы в настройках браузера. Разрешите их для этого сайта
          в настройках сайта, затем вернитесь сюда.
        </p>
      );
    }

    if (needsIosHomeScreen()) {
      return (
        <p className="pp-webpush-note">
          На iPhone и iPad уведомления работают только для сайта, добавленного на экран «Домой».
          Откройте меню «Поделиться», выберите «На экран „Домой“», затем включите уведомления оттуда.
        </p>
      );
    }

    if (state === WEB_PUSH_STATE.SUBSCRIBED) {
      return (
        <>
          <p className="pp-webpush-note">Уведомления включены на этом устройстве.</p>
          <Button size="sm" variant="outline-secondary" disabled={busy} onClick={disable}>
            {busy ? 'Отключаем…' : 'Отключить на этом устройстве'}
          </Button>
        </>
      );
    }

    return (
      <>
        <Button size="sm" variant="primary" disabled={busy} onClick={enable}>
          {busy ? 'Включаем…' : 'Включить уведомления'}
        </Button>
      </>
    );
  };

  return (
    <div className="pp-webpush">
      <h6 className="pp-section-title">Web Push</h6>
      {renderBody()}
      {error && <div className="pp-password-error">{error}</div>}
    </div>
  );
};

export default WebPushSection;
